// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"43":"test","182":"exam2","657":"report2"}[chunkId] + "-legacy." + {"43":"daa3b6d4","182":"c8100b6b","657":"4a57951e"}[chunkId] + ".js";
};